import React from 'react';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import t from 'utils/translate';
import { selectCompanySettings, selectDataLoaded } from 'modules/settings/stores/company-settings-slice-handler';
import { selectSettingsJson, updateJsonSetting } from 'modules/settings/stores/user-settings-slice-handler';
import { useSelector } from 'react-redux';
import ActiveInactiveSelector from './active-inactive-selector';
import CallAutoAnswerOptions from './call-auto-answer-options';

function SectionAutoAnswer() {
    const dataLoaded = useSelector(selectDataLoaded);
    /**
     * @type {CompanySettings}
     */
    const companySettings = useSelector(selectCompanySettings);
    /**
     * @type {UserSettingsJson}
     */
    const settingsJson = useSelector(selectSettingsJson);

    if (!dataLoaded) {
        return '';
    }

    // no auto answer feature
    if (!companySettings.AllowVoip && !companySettings.AllowWalkieTalkie && !companySettings.AllowAmbientListening) {
        return;
    }

    return (
        <div className="settings-section" data-test-id="auto-answer">
            <div className="settings-section-title">
                <LabelWithInfo text={t('settings_auto_response')} />
                <div className="strike" />
            </div>
            <div className={'section-content'}>
                {companySettings.AllowAmbientListening && (
                    <div className="section-row" data-test-id={`ambient-listening-auto-answer`}>
                        <LabelWithInfo
                            text={t('settings_ambient_listening_auto_answer')}
                            info={t('settings_ambient_listening_auto_answer_tooltip')}
                            tooltipPlacement="right"
                        />
                        <ActiveInactiveSelector
                            initialValue={settingsJson.ambientListeningAutoAnswer}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'ambientListeningAutoAnswer',
                                    v,
                                    t('settings_auto_response'),
                                    t('settings_ambient_listening_auto_answer_changed_successfully'),
                                );
                            }}
                        ></ActiveInactiveSelector>
                    </div>
                )}
                {companySettings.AllowWalkieTalkie && (
                    <div className="section-row" data-test-id={`emergency-ptt-auto-answer`}>
                        <LabelWithInfo
                            text={t('settings_emergency_ptt_call_auto_answer')}
                            info={t('settings_emergency_ptt_call_auto_answer_tooltip')}
                            tooltipPlacement="right"
                        />
                        <ActiveInactiveSelector
                            initialValue={settingsJson.emergencyPttCallAutoAnswer}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'emergencyPttCallAutoAnswer',
                                    v,
                                    t('settings_auto_response'),
                                    t('js_all_emergency_ptt_autoresponse_changed_successfully'),
                                );
                            }}
                        ></ActiveInactiveSelector>
                    </div>
                )}
                {companySettings.AllowWalkieTalkie && (
                    <div className="section-row" data-test-id={`ptt-auto-answer`}>
                        <LabelWithInfo
                            text={t('settings_walkie_talkie_autoanswer')}
                            info={t('settings_walkie_talkie_autoanswer_tooltip')}
                            tooltipPlacement="right"
                        />
                        <CallAutoAnswerOptions
                            isPttCall
                            initialValue={settingsJson.walkieTalkieAutoresponse}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'walkieTalkieAutoresponse',
                                    v,
                                    t('settings_auto_response'),
                                    t('js_all_ptt_autoresponse_changed_successfully'),
                                );
                            }}
                        ></CallAutoAnswerOptions>
                    </div>
                )}
                {companySettings.AllowVoip && (
                    <div className="section-row" data-test-id={`voip-auto-answer`}>
                        <LabelWithInfo
                            text={t('settings_call_autoanswer')}
                            info={t('settings_call_autoanswer_tooltip')}
                            tooltipPlacement="right"
                        />
                        <CallAutoAnswerOptions
                            initialValue={settingsJson.callAutoresponse}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'callAutoresponse',
                                    v,
                                    t('settings_auto_response'),
                                    t('js_all_voip_autoresponse_changed_successfully'),
                                );
                            }}
                        ></CallAutoAnswerOptions>
                    </div>
                )}
                {companySettings.AllowVoip && companySettings.AllowAudioConference && (
                    <div className="section-row" data-test-id={`conference-auto-answer`}>
                        <LabelWithInfo
                            text={t('settings_conference_call_autoanswer')}
                            info={t('settings_conference_call_autoanswer_tooltip')}
                            tooltipPlacement="right"
                        />
                        <CallAutoAnswerOptions
                            initialValue={settingsJson.conferenceCallAutoAnswer}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'conferenceCallAutoAnswer',
                                    v,
                                    t('settings_auto_response'),
                                    t('js_all_conference_autoresponse_changed_successfully'),
                                );
                            }}
                        ></CallAutoAnswerOptions>
                    </div>
                )}
            </div>
        </div>
    );
}
export default SectionAutoAnswer;
